import React from 'react';

const ThankYouPage = () => {
    return (
        <div className="container-fluid vh-100 d-flex flex-column justify-content-center align-items-center bg-light">
            <div className="card p-5 shadow-lg text-center" style={{ maxWidth: '600px' }}>
                <div className="card-body">
                    <div className="mb-4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="64"
                            height="64"
                            fill="#28a745"
                            className="bi bi-check-circle-fill"
                            viewBox="0 0 16 16"
                        >
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                        </svg>
                    </div>
                    <h1 className="mb-3 text-success">Thank You!</h1>
                    <p className="lead mb-4">
                        Your submission has been received successfully. We appreciate your time and will get back to you soon.
                    </p>
                    <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                        <a
                            href="/"
                            className="btn btn-primary btn-lg px-4 gap-3"
                        >
                            Return Home
                        </a>
                        <a
                            href="/contact"
                            className="btn btn-outline-secondary btn-lg px-4"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThankYouPage;